<template>
  <div :class="$style.root">
    <div style="right:1.5em;position:absolute;">
       Ver 1.03<br/>
       23/01/2023
    </div>
    <div :class="$style.container">
      <img :class="$style.logo" src="@/assets/images/logo.svg" alt="Logo" />
      <h1 :class="$style.title">ระบบหน้าร้าน</h1>
      <LoginForm ref="form" :class="$style.form" @submit="handleSubmit" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LoginForm from '@/components/page/login/LoginForm.vue'
import { RequestError } from '@/error'

export default {
  components: { LoginForm },

  created() {
    document.documentElement.style.height = '100%'
    document.body.style.height = '100%'
  },

  beforeDestroy() {
    document.documentElement.style.height = ''
    document.body.style.height = ''
  },

  methods: {
    ...mapActions('auth', ['login']),

    ...mapActions('goldPrice', {
      fetchGoldPrice: 'fetch'
    }),

    async handleSubmit(form) {
      try {
        await this.login(form)
        this.$router.push(
          this.$route.query.redirect
            ? this.$route.query.redirect
            : { name: 'Home' }
        )
      } catch (err) {
        if (err instanceof RequestError) {
          this.$notify.error('ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง')
          this.$refs.form.reset()
        }
      }
    }
  }
}
</script>

<style lang="scss" module>
.root {
  margin: 0 auto;
  background-color: #d9251d;
  height: 100%;
  overflow: auto;
  display: flex;
  color: #ffffff;
}

.container {
  padding: 1rem;
  width: 36rem;
  margin: auto;
}

.logo {
  display: block;
  margin: 0 auto;
}

.title {
  text-align: center;
  font-size: 1.5rem;
}

.form {
  margin-top: 3rem;
}

.footer {
  text-align: center;
}
</style>
